import React from "react";
import { NavLink } from "react-router-dom";

import {
  SidebarDrawerMenu as SidebarDrawerMenuTelluriaUi,
  SidebarDrawerMenuProps as SidebarDrawerMenuPropsTelluriaUi
} from "@npm-telluria-tecnologia/telluria-ui";

export interface SidebarDrawerMenuProps extends SidebarDrawerMenuPropsTelluriaUi {
  link: string;
}

const SidebarDrawerMenu: React.FC<SidebarDrawerMenuProps> = ({
  id, title, icon, identifierColor, secondaryColor, link, type, onClick
}) => (
  <NavLink to={link}>
    <SidebarDrawerMenuTelluriaUi
      id={id}
      title={title}
      icon={icon}
      identifierColor={identifierColor}
      secondaryColor={secondaryColor}
      type={type}
      onClick={onClick}
    />
  </NavLink>
);

export default SidebarDrawerMenu;
